import withUser from '~lib/common/hoc/withUser';

import OrgGroups from './OrgGroups';

export default withUser()(OrgGroups);
